import React from 'react';
import IMG1 from '../../assets/Sephora.png';
import IMG2 from '../../assets/dot&key.png';
import IMG3 from '../../assets/lifestyle.png';
import IMG4 from '../../assets/Mythresa.png';
import IMG5 from '../../assets/Hound.jpg';

import './portfolio.css';

const Portfolio = () => {
  const soloProjects = [
    {
      id: 1,
      title: 'Mythresa.com clone',
      img: IMG4,
      description:'Clone of a famous E-commerce Website, built using MERN Stack by a team of 5 includes FrontEnd & Backend,functionality: SignUp,SignIn,Shopping Cart, filter, add to cart, payment',
      technologies: 'React | Node Js | Express Js| Javascript | HTML | CSS | MongoDB | Chakra Ui',
      link: 'https://violent-hope.netlify.app/',
      github: 'https://github.com/Vivek-Nemade/violent-hope-9407',
    },
    {
      id: 2,
      title: 'HOUND Blog website',
      img: IMG5,
      description:
        'MERN Stack based blog platform where user can perform various operations Post Blogs,like,comment on blog,can follow other authors',
      technologies: 'React | MongoDB | Redux | Node | HTML | CSS | MUI | Express ',
      link: 'https://hound-frontend-service.vercel.app/',
      github: 'https://github.com/Vivek-Nemade/HOUND_FRONTEND',
    },
    {
      id: 3,
      title: 'DotandKey.com clone ',
      img: IMG2,
      description:
        'This is clone of "DotandKey.com" showcase E-commerce application where Reat-Redux is used to handle all actions in diffrenet usecases, funtionality includes Login,SignUp,add to cart,payment etc',
      technologies: 'React | Redux | Javascript | HTML | CSS | Bootstrap |Chakra Ui',
      link: 'https://dotandkey2.netlify.app/',
      github: 'https://github.com/Vivek-Nemade/Dot-and-key-project-unit-4',
    },
    // {
    //   id: 3,
    //   title: 'Lifestyle.com clone',
    //   img: IMG3,
    //   description: 'This is clone of "Lifestyle.com" showcase E-commerce application where user can perform various operations like Login,SignUp,filter,add to cart,payment etc',
    //   technologies: 'JavaScript | HTML | CSS | Bootstrap',
    //   link: 'https://vivek-nemade.github.io/LifeStyle-Store/',
    //   github: 'https://github.com/Vivek-Nemade/LifeStyle-Store',
    // },
    {
      id: 4,
      title: 'Sephora.com clone',
      img: IMG1,
      description:
        'This is clone of "Sephora.com" showcase E-commerce application where user can perform various operations like Login,SignUp,add favourite,add to cart,payment etc',
      technologies: 'Javascript | HTML | CSS | Bootstrap | JQuery',
      link: 'https://vivek-nemade.github.io/sephora_clone/',
      github: 'https://github.com/Vivek-Nemade/sephora_clone',
    },
    
    // {
    //   id: 6,
    //   title: 'Math Resource',
    //   img: IMG6,
    //   description:
    //     'Real-world group project which is still in progress and will provide educational platform for future young developers',
    //   technologies: 'JavaScript | Scss | Python',
    //   link: 'https://lukinoo.github.io/math-resource/',
    //   github: 'https://github.com/lukinoo/math-resource',
    // },
  ];

  return (
    <section id="portfolio">
      <h5 style={{color:"#6b6767"}}>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {soloProjects.map((pro) => (
          <article className="portfolio__item" key={pro.id}>
            <div className="portfolio__item-image">
              <img className="website-img" src={pro.img} alt={pro.title} />
            </div>
            <div className="portfolio__item-content">
              <h3>{pro.title}</h3>
              <p>{pro.description}</p>
              <p className="stack">{pro.technologies}</p>
            </div>
            <div className="portfolio__item-cta">
              <a
                href={pro.github}
                target="_blank"
                className="btn"
                rel="noreferrer"
                id='git'
              >
                GitHub
              </a>
              <a
                href={pro.link}
                target="_blank"
                className="btn btn-primary"
                rel="noreferrer"
                id='live'
              >
                Live Demo
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
